import { ASDCUser } from "../../../types/user.types";
import {
  Background,
  Form,
  FormHeader,
  InputsContainer,
  InputsGroup,
  InputContainer,
  Label,
  Input,
  SelectStatus,
  AddButton,
  CancelButton,
} from "../addClientModal/addClientModal.styles";
import eye from "../../../assets/icons/eye.svg";
import eyeOff from "../../../assets/icons/eyeBlock.svg";
import { useState, useRef, useContext, useEffect } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Get, SendFormData, handleError } from "../../../utils/fetch.util";
import { UserContext } from "../../../contexts/user.context";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { Company } from "../../../types/company.types";
import Image from "../../Image/Image.component";
const DEFAULT_USER: ASDCUser = {
  asdc_client_user_name: "",
  asdc_client_user_mobile: "",
  asdc_client_user_email: "",
  asdc_client_user_password: "",
  // asdc_client_user_dob: "",
  asdc_client_contract_id: "",
  asdc_client_user_type: "web",
  profile_pic: "",
  NationalID: null,
  subscription_id: "",
  user_on_mission: false,
};
type PassedContracts = { id: any; name: string }[] | undefined;
type AddUserModalProps = {
  services: any[];
  contracts: PassedContracts;
  subscriptions: any[];
  toggleAddUserModal: () => void;
  qrcode: string;
  asdc_client_id: number;
  isShown: boolean;
  companyName: string;
  admins: any;
  setAdmins: any;
};

export const createFormData = (company: any | null) => {
  const formData = new FormData();
  if (!company) return formData;
  for (const key in company) {
    formData.append(key, company[key]);
  }
  return formData;
};

const AddUserModal = ({
  contracts,
  toggleAddUserModal,
  qrcode,
  asdc_client_id,
  isShown,
  admins,
  setAdmins,
  subscriptions,
}: AddUserModalProps) => {
  const [user, setUser] = useState<ASDCUser>({
    ...DEFAULT_USER,
    asdc_client_contract_id: contracts?.[0]?.id,
    qrcode,
    asdc_client_id,
    subscription_id: subscriptions?.[0]?.subscription_id,
  });
  const [client, setClient] = useState<Company>();
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const { getValidToken } = useContext(UserContext);
  const profilePicRef = useRef<HTMLInputElement>(null);
  const { t } = useTranslation();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    setUser({ ...user, [name]: value });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const profilePic = profilePicRef.current?.files?.[0];
    const formData = createFormData({
      ...user,
      asdc_client_user_mobile: user?.asdc_client_user_mobile?.replace(" ", ""),
      asdc_client_id: asdc_client_id,
      qrcode: qrcode,
      // asdc_client_user_dob: new Date(user.asdc_client_user_dob)?.toISOString(),
      asdc_client_user_email: `${user.asdc_client_user_email}@${client?.sub_domain}`,
    });
    if (profilePic) formData.append("profile_pic", profilePic);
    formData.append("create_staff", "true");
    setIsLoading(true);
    const response = await SendFormData(
      "asdc-client-user/add-client-admin",
      formData,
      getValidToken()
    );
    if (response?.error || !response?.data) {
      handleError(response);
      setIsLoading(false);
      return;
    }
    setAdmins([...admins, response.data]);
    setIsLoading(false);
    toggleAddUserModal();
    if (profilePicRef.current) {
      profilePicRef.current.value = "";
    }
    setUser({
      ...DEFAULT_USER,
      asdc_client_contract_id: contracts?.[0]?.id,
      qrcode,
      asdc_client_id,
      subscription_id: subscriptions?.[0]?.subscription_id,
    });
    toast.success("User Added Successfully");
  };

  useEffect(() => {
    if ((contracts === undefined || !contracts?.length) && isShown) {
      toast.error("No Contracts Found", {
        toastId: "no_contracts",
      });
      toggleAddUserModal();
    }
    setUser({ ...user, asdc_client_contract_id: contracts?.[0]?.id });
  }, [contracts]);

  useEffect(() => {
    setUser({ ...user, asdc_client_id: asdc_client_id });
  }, [asdc_client_id]);

  useEffect(() => {
    const getClient = async () => {
      const res = await Get(
        `asdc-client/get-whole-client?qrcode=${qrcode}`,
        getValidToken()
      );

      setClient(res.data);
    };

    getClient();
  }, []);


  if (!contracts?.length) {
    return <></>;
  }
  return (
    <Background
      style={{
        opacity: isShown ? "1" : "0",
        pointerEvents: isShown ? "all" : "none",
      }}
    >
      <Form className="!h-[auto] !w-fit" onSubmit={handleSubmit}>
        <FormHeader className="text-center !mb-8 !text-3xl">
          {t("add_admin_user")}
        </FormHeader>
        <InputsContainer>
          <InputsGroup>
            <InputContainer>
              <Label>{t("adminDashboard__name")}</Label>
              <Input
                type="text"
                name="asdc_client_user_name"
                value={user.asdc_client_user_name}
                onChange={handleChange}
                required
              />
            </InputContainer>
            <InputContainer>
              <Label>{t("email")}</Label>
              <InputContainer style={{ display: "flex", flexDirection: "row" }}>
                <Input
                  type="text"
                  name="asdc_client_user_email"
                  value={user.asdc_client_user_email}
                  onChange={handleChange}
                  required
                />
                <Input
                  type="email"
                  value={`@${client?.sub_domain || "Subdomain"}`}
                  disabled
                />
              </InputContainer>
            </InputContainer>
            <div className="flex flex-col gap-1 relative">
              <Label>{t("password")}</Label>
              <Input
                type={`${showPassword ? "text" : "password"}`}
                name="asdc_client_user_password"
                value={user.asdc_client_user_password}
                style={{ textAlign: "left" }}
                onChange={handleChange}
                required
              />
              {showPassword ? (
                <img
                  src={eyeOff}
                  alt="eye"
                  className="absolute bottom-2 right-2 cursor-pointer opacity-75"
                  onClick={() => setShowPassword(!showPassword)}
                />
              ) : (
                <img
                  src={eye}
                  alt="eye"
                  className="absolute bottom-3 right-2 cursor-pointer opacity-75"
                  onClick={() => setShowPassword(!showPassword)}
                />
              )}
            </div>
            <InputContainer>
              <Label>{t("editCompany__phone")}</Label>
              <PhoneInput
                country="ae"
                value={user.asdc_client_user_mobile}
                inputProps={{
                  style: { width: "100%" },
                  // maxLength: 15,
                  // minLength: 11,
                }}
                inputStyle={{ height: "38px", direction: "ltr" }}
                onChange={(phone: any) =>
                  setUser({ ...user, asdc_client_user_mobile: "+" + phone })
                }
                enableSearch={true}
              />
            </InputContainer>
          </InputsGroup>
          <InputsGroup>
            <InputContainer>
              <Label>{t("national_id")}</Label>
              <InputContainer style={{ display: "flex", flexDirection: "row" }}>
                <Input
                  type="number"
                  name="NationalID"
                  value={user.NationalID || ""}
                  onChange={(e: any) => {
                    // if (e?.target?.value.length > 14) {
                    //   return;
                    // }
                    setUser({ ...user, NationalID: e?.target?.value });
                  }}
                  className="w-full"
                />
              </InputContainer>
            </InputContainer>

            <InputContainer>
              <Label>{t("passport_id")}</Label>
              <InputContainer style={{ display: "flex", flexDirection: "row" }}>
                <Input
                  type="number"
                  name="PassportNumber"
                  value={user.PassportNumber || ""}
                  onChange={(e: any) => {
                    // if (e?.target?.value.length > 14) {
                    //   return;
                    // }
                    setUser({ ...user, PassportNumber: e?.target?.value });
                  }}
                  className="w-full"
                  // required
                />
              </InputContainer>
            </InputContainer>

            {/* <InputContainer>
              <Label>{t("date_of_birth")}</Label>
              <Input
                type="date"
                name="asdc_client_user_dob"
                value={user.asdc_client_user_dob}
                onChange={handleChange}
              />
            </InputContainer> */}
            <InputContainer>
              <Label>{t("user_type")}</Label>
              <SelectStatus
                onChange={(e: any) =>
                  setUser({ ...user, asdc_client_user_type: e.target.value })
                }
              >
                <option value="web">{t("web_user")}</option>
                <option value="mobile">{t("mobile_user")}</option>
                <option value="web_mobile">{t("web_mobile_user")}</option>
              </SelectStatus>
            </InputContainer>

            <InputContainer>
              <Label>{t("contract")}</Label>
              <SelectStatus
                onChange={(e: any) =>
                  setUser({
                    ...user,
                    asdc_client_contract_id: e.target.value,
                  })
                }
              >
                {contracts?.map((contract: any, i: number) => (
                  <option key={`contract__${i}_`} value={contract.id}>
                    {contract.name}
                  </option>
                ))}
              </SelectStatus>
            </InputContainer>
            <InputContainer>
              <Label>{t("subscription")}</Label>
              <SelectStatus
                onChange={(e: any) => {
                  setUser({
                    ...user,
                    subscription_id: e.target.value,
                  });
                }}
                value={user.subscription_id}
              >
                {subscriptions?.map((subscription: any, i: number) => (
                  <option
                    key={`subscription__${i}_`}
                    value={subscription.subscription_id}
                  >
                    {subscription.subscription_title}
                  </option>
                ))}
              </SelectStatus>
            </InputContainer>
            <InputContainer>
              <Label>{t("profile_picture")}</Label>
              <Input
                type="file"
                name="profile_pic"
                ref={profilePicRef}
                onChange={(e: any) => {
                  setUser({
                    ...user,
                    profile_pic: URL.createObjectURL(e?.target?.files![0]),
                  });
                }}
                required
              />

              {user.profile_pic && (
                <Image
                  src={user.profile_pic}
                  className="w-[100px] h-[100px] object-contain"
                  alt="super_admin_profile_pic"
                  addBaseLink={false}
                />
              )}
            </InputContainer>
          </InputsGroup>
        </InputsContainer>
        <div className="flex items-center gap-1 w-full mt-4">
          <input
            className="rounded-md border-[1px] w-[20px] h-[20px]"
            type="checkbox"
            checked={user.user_on_mission}
            onChange={(e) => setUser({ ...user, user_on_mission: e.target.checked })}
          />
          <label>{t("user_on_mission")}</label>
        </div>
        <div className="flex w-full gap-12 mt-8 items-center">
          <AddButton
            className="!bg-[#64A7C4] !text-white"
            type="submit"
            isLoading={isLoading}
          >
            {t("add_admin_user")}
          </AddButton>
          <CancelButton onClick={toggleAddUserModal} type="button">
            {t("cancelBtn")}
          </CancelButton>
        </div>
      </Form>
    </Background>
  );
};

export default AddUserModal;
